<template>
  <div class="palette-container">
    <div class="palette-item-list-nav">
      <a class="palette-item-list-prev" href="#" @click.prevent="scrollPrev"></a>
    </div>
    <VuePerfectScrollbar ref="scroll" class="palette-item-list" :settings="scrollSettings">
      <palette-item v-for="config in configs" :key="config.id" :config="config"></palette-item>
    </VuePerfectScrollbar>
    <div class="palette-item-list-nav">
      <a class="palette-item-list-next" href="#" @click.prevent="scrollNext"></a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import PaletteItem from './PaletteItem'

export default {
  components: {
    VuePerfectScrollbar,
    PaletteItem,
  },
  data() {
    return {
      scrollSettings: {
        useBothWheelAxes: true,
        suppressScrollY: true,
      },
    }
  },
  computed: {
    ...mapState({
      itemType: state => state.palette.itemType,
      floor: state => state.editor.floor,
    }),
    configs() {
      return this.$store.getters['item/configsByType'](this.itemType, this.floor)
    },
  },
  watch: {
    itemType() {
      this.scrollReset()
    },
  },
  methods: {
    scrollReset() {
      this.$refs.scroll.$el.scrollLeft = 0
    },
    scrollPrev() {
      this.$refs.scroll.$el.scrollLeft -= this.$refs.scroll.$el.clientWidth
    },
    scrollNext() {
      this.$refs.scroll.$el.scrollLeft += this.$refs.scroll.$el.clientWidth
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../sass/bootstrap";

.palette-container {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 7px 0;
}
.palette-item-list-nav {
  flex: 0 0 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.palette-item-list-prev {
  align-self: flex-start;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 21px;
  height: 54px;
  border-radius: 0 5px 5px 0;
  @include transition($btn-transition);
  @include button-variant(#513F26, #513F26, #eb9848, #eb9848, #eb9848, #eb9848);
  &:before {
    content: '';
    display: block;
    margin-left: -3px;
    border-top: 10px solid transparent;
    border-left: 0 solid transparent;
    border-right: 6px solid #fff;
    border-bottom: 10px solid transparent;
  }
}
.palette-item-list-next {
  align-self: flex-end;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 21px;
  height: 54px;
  border-radius: 5px 0 0 5px;
  @include transition($btn-transition);
  @include button-variant(#513F26, #513F26, #eb9848, #eb9848, #eb9848, #eb9848);
  &:before {
    content: '';
    display: block;
    margin-right: -3px;
    border-top: 10px solid transparent;
    border-left: 6px solid #fff;
    border-right: 0 solid transparent;
    border-bottom: 10px solid transparent;
  }
}
.palette-item-list {
  flex: 1 1 auto;
  display: flex;
  // margin: 5px 0;
  padding-bottom: 10px;
  // height: calc(100% - 20px);
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  overflow-x: scroll;
}
</style>

<style lang="scss">
@import "../../../sass/bootstrap";

.palette-item-list.ps {
  & > .ps__scrollbar-x-rail {
    height: 10px;
  }
  &.ps--active-x > .ps__scrollbar-x-rail {
    @include gradient-y(#67513A, #7F5D3B);
    opacity: 1;
    border-radius: 5px;
  }
  & > .ps__scrollbar-x-rail > .ps__scrollbar-x {
    bottom: 0;
    height: 10px;
    background-color: transparent;
    // bottom: 1px;
    // height: 8px;
    // background-color: #a4c659;
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 1px;
      left: 1px;
      right: 1px;
      bottom: 1px;
      background-color: #a4c659;
      border-radius: 4px;
    }
  }
  &.ps--in-scrolling.ps--x > .ps__scrollbar-x-rail > .ps__scrollbar-x,
  &:hover.ps--in-scrolling.ps--x > .ps__scrollbar-x-rail > .ps__scrollbar-x,
  &:hover > .ps__scrollbar-x-rail:hover > .ps__scrollbar-x {
    height: 10px;
    background-color: transparent;
    // height: 8px;
    &:before {
      background-color: #abf678;
    }
  }
}
</style>


// WEBPACK FOOTER //
// assets/js/components/palette/Palette.vue